$(document).ready(function() {
    $(window).load(function(){
      //Google Map          
	      var latlng = new google.maps.LatLng(35.66269550725334, 138.57073716850212);
      var settings = {
        zoom: 17,
        center: new google.maps.LatLng(35.66269550725334, 138.57073716850212), mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        scrollwheel: false,
        draggable: true,
        mapTypeControlOptions: {style: google.maps.MapTypeControlStyle.DROPDOWN_MENU},
        zoomControlOptions: {position: google.maps.ControlPosition.RIGHT_CENTER},
        streetViewControl: true,
        streetViewControlOptions: {position: google.maps.ControlPosition.RIGHT_CENTER},
        fullscreenControlOptions: {position: google.maps.ControlPosition.LEFT_CENTER},
        navigationControl: false,
        navigationControlOptions: {style: google.maps.NavigationControlStyle.SMALL},
        mapTypeId: google.maps.MapTypeId.ROADMAP};
      var map = new google.maps.Map(document.getElementById("map_canvas"), settings); 
      google.maps.event.addDomListener(window, "resize", function() {
        var center = map.getCenter();
        google.maps.event.trigger(map, "resize");
        map.setCenter(center);
      }); 
      var contentString = 
        '<div id="googlemap_wrap">'+
        '  <h3 id="hl_googlemap">TO LABO shop&studio</h3>'+
        '  <div id="txt_googlemap">'+
        '    <p>〒400-0031 山梨県甲府市丸の内１丁目１４−１４<br>オリオン共同ビル 104<br>104 1-14-14 Marunouchi Kofu Yamanashi 400-0031<br><a href="https://www.google.co.jp/maps/place/TO+LABO+shop%26studio/@35.6626361,138.5707706,15z/data=!4m6!3m5!1s0x601bf9cf85c94211:0x17fecde9b3d5d73d!8m2!3d35.6626361!4d138.5707706!16s%2Fg%2F11b5plf1__" target="_blank">GOOGLE MAP</a></p>'+
        '  </div>'+
        '</div>';
      var infowindow = new google.maps.InfoWindow({
        content: contentString
      }); 
      var companyImage = new google.maps.MarkerImage("https://cdn.shopify.com/s/files/1/0622/1978/0234/t/11/assets/marker.png",
        new google.maps.Size(63,68), //マーカーの幅と高さ
        new google.maps.Point(0,0),
        new google.maps.Point(27,50) //マーカーの位置
      );
      var companyPos = new google.maps.LatLng(35.66269550725334, 138.57073716850212); 
      var companyMarker = new google.maps.Marker({
        position: companyPos,
        map: map,
        icon: companyImage,               
        zIndex: 3});
      google.maps.event.addListener(companyMarker, "click", function() {
        infowindow.open(map,companyMarker);
      });

//color change
	  var stylez = [{"stylers":[{ "saturation": -100 },{ lightness: 0 },{ gamma: 1.0 },{hue: "#fff"}]}];
	  var styledMapOptions = {}
	  var styledMapType =  new google.maps.StyledMapType(stylez,styledMapOptions);
	  map.mapTypes.set('TO LABO shop&studio', styledMapType);
	  map.setMapTypeId('TO LABO shop&studio');

    });
  
});